import { createSlice, current } from "@reduxjs/toolkit";
import AuthService from "services/auth.service";
import OnDemandService from "services/on-demand.service";

export const ondemandSlice = createSlice({
  name: "theTeleconsultOnDemand",
  initialState: {
    showIncomingRequest: false,
    incomingRequestData: null,
    terminateSession: false
  },
  reducers: {
    setShowIncomingRequest: (state, action) => {
      let isNewRequest = true;
      let currentState = current(state);

      if (currentState.incomingRequestData !== null) {
        isNewRequest =
          currentState.incomingRequestData.teleconsult_on_demand_id !==
          action.payload.id;
      }

      if (action.payload.status === false) {
        // Only close current request
        if (isNewRequest === false) {
          state.showIncomingRequest = action.payload.status;
        }
      } else {
        state.showIncomingRequest = action.payload.status;
      }
    },
    setIncomingRequestData: (state, action) => {
      // Only show new request when there is no pending request
      if (state.showIncomingRequest === false) {
        state.incomingRequestData = action.payload;
      }
    },
    setTerminateSession: (state, action) => {
      state.terminateSession = action.payload.status;
    }
  },
});

// Action creators are generated for each case reducer function
export const { setShowIncomingRequest, setIncomingRequestData, setTerminateSession } = ondemandSlice.actions;
export const ondemandSelector = (state) => state.theTeleconsultOnDemand;

export default ondemandSlice.reducer;

// Asynchronous thunk action
export function showIncomingRequestModal(info) {
  return async (dispatch) => {
    dispatch(setTerminateSession({status: false}));
    const currentUser = AuthService.getCurrentUser();

    OnDemandService.getStatus({ doctor_id: currentUser.id }).then(
      (data) => {
        if (data) {
          if (info?.action === "call") {
            dispatch(setIncomingRequestData(info));
            dispatch(
              setShowIncomingRequest({
                status: true,
                id: info.teleconsult_on_demand_id,
              })
            );
          }else if (info?.action === 'end'){
            dispatch(setTerminateSession({status: true}));
          }else if (info?.action === 'initial_teleconsult_on_demand'){
            if (info?.pending_cases?.length > 0){
              //means got data, then take the latest one and show
              var lastPendingCases = info?.pending_cases?.[info?.pending_cases.length - 1]
              dispatch(setIncomingRequestData(lastPendingCases));
              dispatch(
                setShowIncomingRequest({
                  status: true,
                  id: lastPendingCases?.teleconsult_on_demand_id,
                })
              );
            }
          }else {
            dispatch(
              setShowIncomingRequest({
                status: false,
                id: info.teleconsult_on_demand_id,
              })
            );
          }
        }
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace("/eb/login");
        }
      }
    );
  };
}
